import styled from 'styled-components';

import {
  ArticleWrapper,
  ContentContainer,
  StyledSection,
} from '@components/atoms';
import { Advantage } from '@shared/constants/advantages';
import { SectionHeader, Article, ServiceCard } from '@components/molecules';
import { ForwardedRef, forwardRef } from 'react';

type AdvantagesProps = {
  content: Advantage[];
};

function Advantages(
  { content }: AdvantagesProps,
  ref: ForwardedRef<HTMLDivElement | null>
) {
  return (
    <StyledSection ref={ref}>
      <ContentContainer>
        <SectionHeader
          title="Our Advantages are endlessssss"
          src="icons/rocket-green.svg"
          gradient
        />

        <ArticleWrapper>
          <Article
            align="center"
            titleMaxWidth="450px"
            descriptionMaxWidth="750px"
            wrapAlign="center"
            wrapWidth="100%"
            title="Quality Services Is Our Law"
            description="With years of industry experience, we've honed our expertise to offer a comprehensive range of logistics solutions tailored to meet the unique needs of our clients."
          />
        </ArticleWrapper>

        <CardWrapper>
          {content?.map(({ title, image, description }) => {
            return (
              <ServiceCard
                title={title}
                description={description}
                image={image}
                key={title}
              />
            );
          })}
        </CardWrapper>
      </ContentContainer>
    </StyledSection>
  );
}

const CardWrapper = styled.div`
  width: 100%;

  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
`;

export default forwardRef<HTMLDivElement | null, AdvantagesProps>(Advantages);
